import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { DataSource } from '../../../enums/DataSource';
import { strings } from '../../../resources/strings';
import { RecipeTable } from '../../../enums/RecipeTable';
import { CustomerRecipe } from '../../../models/CustomerRecipe';
import { CardCustomerRecipe } from '../CardCustomerRecipe/CardCustomerRecipe';

interface ITabRecipeHistoryProps {
  recipes?: CustomerRecipe[];
  orderDataSource?: DataSource;
  readonly?: boolean;
  editRecipe?: (recipeId: number, recipeTable: RecipeTable) => void;
  deleteRecipe?: (recipeId: number, recipeTable: RecipeTable) => void;
}

const TabRecipeHistory: React.FC<ITabRecipeHistoryProps> = ({
  recipes,
  orderDataSource,
  readonly,
  editRecipe,
  deleteRecipe
}) => {

  const body = React.useMemo(() => {
    const numberOfRecipes = recipes?.length || 0;
    const orderHasAnyRecipe = numberOfRecipes > 0;

    if (!orderHasAnyRecipe) {
      return <Alert variant='warning'>
              {strings.NoneRecipeFound}
            </Alert>;
    }

    return recipes?.map(recipe => {
      return <CardCustomerRecipe
              key={`recipe-${recipe.id}`}
              recipe={recipe}
              editRecipe={editRecipe ? (() => editRecipe(recipe.id, RecipeTable.CustomerRecipe)) : undefined}
              deleteRecipe={deleteRecipe ? (() => deleteRecipe(recipe.id, RecipeTable.CustomerRecipe)) : undefined}
              orderDataSource={orderDataSource}
              readonly={readonly}
              showExpanded={numberOfRecipes === 1}
            />;
    });
  }, [recipes, orderDataSource, readonly, editRecipe, deleteRecipe]);

  return (
    <>
      {body}
    </>
  );
}

export { TabRecipeHistory };